import type { Translate } from '@/utils/hooks/translation/useTranslation';

// Types
import type { SocialProfileNetworkType } from '@/types/socialProfileType';

// Utils
import {
    FACEBOOK,
    INSTAGRAM,
    LINKEDIN,
    PINTEREST,
    THREADS,
    TIKTOK_BUSINESS,
    TWITTER,
    X,
    YOUTUBE
} from '@/lib/socialProfile';

import type { NavTabsButtonsTabType } from '@/components/composite/NavTabs/NavTabButtons';

export const TAB_POST_INSTAGRAM = 'posts_instagram';
export const TAB_STORIES_INSTAGRAM = 'stories_instagram';
export const TAB_POST_FACEBOOK = 'posts_facebook';
export const TAB_POSTS_X = 'posts_x';
export const TAB_REPLIES_X = 'replies_x';
export const TAB_POST_LINKEDIN = 'posts_linkedin';
export const TAB_POST_TIKTOK = 'posts_tiktok';
export const TAB_POST_YOUTUBE = 'posts_youtube';
export const TAB_PINS_PINTEREST = 'pins_pinterest';
export const TAB_THREADS_THREADS = 'threads_threads';

export const getTabsList = (
    t: Translate
): Record<SocialProfileNetworkType, NavTabsButtonsTabType[]> => {
    return {
        [INSTAGRAM]: [
            { name: 'Posts', icon: 'content', id: TAB_POST_INSTAGRAM },
            { name: 'Stories', icon: 'story', id: TAB_STORIES_INSTAGRAM }
        ],
        [FACEBOOK]: [{ name: 'Posts', icon: 'content', id: TAB_POST_FACEBOOK }],
        [TWITTER]: [],
        [X]: [
            { name: 'Posts', icon: 'x', id: TAB_POSTS_X },
            { name: t('commons:replies_sent'), icon: 'reply', id: TAB_REPLIES_X }
        ],
        [THREADS]: [{ name: 'Threads', icon: 'threads', id: TAB_THREADS_THREADS }],
        [LINKEDIN]: [{ name: 'Posts', icon: 'content', id: TAB_POST_LINKEDIN }],
        [PINTEREST]: [{ name: 'Pins', icon: 'content', id: TAB_PINS_PINTEREST }],
        [TIKTOK_BUSINESS]: [{ name: 'Posts', icon: 'content', id: TAB_POST_TIKTOK }],
        [YOUTUBE]: [{ name: 'Posts', icon: 'content', id: TAB_POST_YOUTUBE }]
    };
};
